export default "__VITE_ASSET__CFY2NoLP__"